// BookingGrandTotalStrip — dark bottom strip showing the estimated
// grand total of the current enquiry. Rendered inside the booking
// widget once at least one priced block exists.
//
// Discreet by design: we display an approximate figure with a small
// caveat about the final billing currency, no commitment.
//
// Extracted from `HomeBookingWidget.jsx`.

import { COPY } from "@/components/booking/homeBookingWidgetCopy";
import { useCurrency, useFormatPrice } from "@/contexts/CurrencyContext";

const pick = (obj, lang) => {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] || obj.en || obj.fr || "";
};

export default function BookingGrandTotalStrip({ total, lang }) {
  const { fromEUR } = useFormatPrice();
  const { currency } = useCurrency();
  if (!total) return null;

  return (
    <div
      className="flex flex-wrap items-baseline justify-between gap-2 px-4 py-3 bg-[#1A1513] text-[#FDFBF7]"
      data-testid="home-booking-grand-total"
    >
      <div>
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#D4A373]">
          {pick(COPY.est_total, lang)}
        </p>
        <p className="mt-0.5 text-[10px] text-[#FDFBF7]/55 leading-snug">
          {(COPY.est_final[lang] || COPY.est_final.en)(currency)}
        </p>
      </div>
      <p className="font-serif-x text-2xl md:text-3xl text-[#FDFBF7]">
        ≈ {fromEUR(total)}
      </p>
    </div>
  );
}
